// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"74ec7460","293":"d9228124","423":"82285460","564":"da85f46c","760":"921e734b","882":"f41f76e5","893":"b2ee351f","910":"0b52c49c"}[chunkId] + ".chunk.css";
};